<template>
    <div class="instruction-list">
        <div v-for="item in instructions" :key="item.id" class="instruction-item">
            <div class="item-label h3">{{ item.label }}</div>
            <div class="item-value">
                <div class="content typography" v-html="item.body" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        instructions?: CmsItem[];
    }>(),
    {
        instructions: () => []
    }
);

const instructions = computed(() => props.instructions);
</script>
